import { render } from "./PopularSection.vue?vue&type=template&id=7b7c299d&scoped=true"
import script from "./PopularSection.vue?vue&type=script&lang=js"
export * from "./PopularSection.vue?vue&type=script&lang=js"

import "./PopularSection.vue?vue&type=style&index=0&id=7b7c299d&lang=scss&scoped=true"

import exportComponent from "/Users/andyhsieh/Desktop/tourist-site-project-master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b7c299d"]])

export default __exports__